<template>
  <slot />
</template>

<script>
import { computed } from "vue";

export default {
  name: "AccordionGroup",
  provide() {
    return {
      addTab: (tab) => {
        const count = this.tabs.push(tab);

        // Ensure the accordion is closed by default.
        if (this.isClosedByDefault) {
          this.activeTabHash = "";
          return;
        }

        // Set the active tab based on the defaultActive flag on the tab itself
        if (tab.isDefault) {
          this.activeTabHash = tab.hash;
        }

        // Open the first tab if no tabs are set to open by default.
        if (!tab.isDefault && count === 1) {
          this.activeTabHash = tab.hash;
        }
      },
      setActiveTabHash: (hash) => {
        if (this.activeTabHash === hash) {
          this.activeTabHash = "";
        } else {
          this.activeTabHash = hash;
        }
      },
      activeTabHash: computed(() => this.activeTabHash),
    };
  },
  props: {
    isClosedByDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTabHash: "",
      tabs: [],
    };
  },
};
</script>
